import type { Routine } from '../types';
import { getPractice } from '../lib/catalog';
import { itemSeconds, routineSeconds } from '../lib/routines';
import { formatLength } from '../lib/timeline';
import { Icon } from '../ui/Icon';
import styles from './routine.module.css';

interface Props {
  routine: Routine;
  onBegin: () => void;
  onEdit?: () => void;
}

/** A session at a glance: its practices in order, total length, Begin and Edit. */
export const RoutineCard = ({ routine, onBegin, onEdit }: Props) => {
  const total = routineSeconds(routine);

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{routine.title}</h2>
      <p className="eyebrow-soft">
        {routine.items.length} {routine.items.length === 1 ? 'practice' : 'practices'}
        {total > 0 ? `, about ${formatLength(total)}` : ''}
      </p>

      {routine.items.length === 0 ? (
        <p className={styles.empty}>This session is empty. Choose Edit to add practices.</p>
      ) : (
        <ol className={styles.steps}>
          {routine.items.map((id, i) => {
            const p = getPractice(id);
            if (!p) return null;
            return (
              <li key={`${id}-${i}`} className={styles.step}>
                <span className={styles.num}>{i + 1}</span>
                <Icon name={p.icon} size={20} className={styles.stepIcon} />
                <span className={styles.stepName}>{p.title}</span>
                <span className={styles.stepTime}>{formatLength(itemSeconds(id, routine))}</span>
              </li>
            );
          })}
        </ol>
      )}

      <button className={`pill-button ${styles.begin}`} onClick={onBegin} disabled={routine.items.length === 0}>
        Begin
      </button>
      {onEdit && (
        <button className="text-button" onClick={onEdit}>
          Edit session
        </button>
      )}
    </div>
  );
};
